<ng-template #socialButtonsRef>
  <div id="socialButtons" appResponsive>
    <app-image-link class="icon" *ngFor="let button of socialButtons" [href]="button.link"
      [src]="nightMode ? button.iconLight : button.iconDark"></app-image-link>
  </div>
</ng-template>

<p class="title" appResponsive>ELUMIXOR</p>

<ng-container *ngIf="desktop else mobile">

  <!-- Social Buttons -->
  <ng-container *ngTemplateOutlet="socialButtonsRef"></ng-container>

  <!-- Theme switcher -->
  <!-- <img id="themeIcon" class="icon button" [src]="themeImage" alt="" (click)="switchMode()"> -->

  <span id="productsContainer">
    <app-products-bar [selected]=0></app-products-bar>
    <app-product [selected]=0></app-product>
  </span>
</ng-container>

<ng-template #mobile>
  <!-- Producs -->
  <app-product-mobile #productRef *ngFor="let product of products" [product]="product"></app-product-mobile>

  <!-- Social Buttons -->
  <ng-container *ngTemplateOutlet="socialButtonsRef"></ng-container>
</ng-template>